import _ from 'lodash'
import constants from '../constants'

const initialConstructionsState = {
  collection: [],
  selected_type: null,
  popup_content: null,
  popup_shown: false,
};

const constructionsReducer = function(state = initialConstructionsState, action) {
  switch(action.type) {
    case constants.ACTIONS.FETCH_CONSTRUCTIONS_SUCCESS:
      return Object.assign({}, state, action.payload);

    case constants.ACTIONS.CONSTRUCTION_TYPE_SELECTED:
      let current_type = _.find(state.collection, item => item.id == action.payload.selected_type_id);
      return Object.assign({}, state, {selected_type: current_type});
    case constants.ACTIONS.SHOW_POPUP:
      return Object.assign({}, state, {popup_content: action.payload.item, popup_shown: true});
    case constants.ACTIONS.HIDE_POPUP:
      return Object.assign({}, state, {popup_content: null, popup_shown: false});
  }

  return state;
};
export default constructionsReducer;


// WEBPACK FOOTER //
// ./app/javascript/app/reducers/constructions.js